import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class TextChatMessage extends AbstractChatMessage {
  body: string = ''

  constructor(data: LX.TextChatMessage) {
    super(data)
    this.body = data.body as string
  }

  static fromServer(data: LX.TextChatMessage) {
    return new TextChatMessage(data)
  }
}
